import { useQuery } from '@tanstack/react-query';
import { InferResponseType, useFanforgeApi } from '@hotpot-arcade/fanforge-api-client';

// todo: consolidate this with the useUserData in ui-components
export const useDiscordId = (userId?: string | null) => {
  const { client: apiClient } = useFanforgeApi();
  type UserData = InferResponseType<(typeof apiClient.users)[':userId']['$get'], 200>;

  const { data } = useQuery({
    queryKey: [userId],
    queryFn: async (): Promise<UserData | null> => {
      const response = await apiClient.users[':userId'].$get({
        param: {
          userId: userId!,
        },
      });

      if (!response.ok) {
        throw new Error(`Failed to fetch user data: ${response.statusText}`);
      }

      const data = await response.json();
      return data;
    },
    enabled: !!userId,
  });

  return data?.discordId ?? null;
};
